import cx from "classnames";
import { Icon } from "common/Icon";
import React from "react";
import styles from "./IntroWidget.scss";

export class IntroWidget extends React.PureComponent {
  render() {
    const { i, left, large, children, className, link } = this.props;
    return (
      <div className={cx(styles.IntroWidget, large && styles.large, className)}>
        <div className={styles.flex}>
          {i && (
            <div className={styles.iconWrap}>
              <div className={styles.iconCircle}>
                <Icon size={large ? 32 : 24} i={i} />
              </div>
            </div>
          )}
          {left && !i && <div className={styles.iconWrap}>{left}</div>}
          <div className={styles.text}>{children}</div>
        </div>
        <div className={styles.link}>{link}</div>
      </div>
    );
  }
}
